<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
        :confirm-loading="confirmLoading" :footer="null" @cancel="onClose" wrap-class-name="single-spa-vue">
        <h4>需求信息：</h4>
        <a-descriptions :column="2" bordered>
            <!-- <a-descriptions-item label="需求ID" name="id" span='2'>{{form.id}}</a-descriptions-item> -->
            <a-descriptions-item label="提交时间" name="createdTime" span='2'>{{form.createdTime}}</a-descriptions-item>
            <a-descriptions-item label="需求类型" name="type" span='2'>
                    <dict-render :dict-obj="dictObjs['adviserType']" :text="form.type" v-if="form.type"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="联系人" name="contacts" span='2'>{{form.contacts}}</a-descriptions-item>
            <a-descriptions-item label="联系人" name="contactNumber" span='2'>{{form.contactNumber}}</a-descriptions-item>
            <!-- <a-descriptions-item label="需求状态" name="demandStatus" span='2'>{{form.demandStatus}}</a-descriptions-item> -->
            <a-descriptions-item label="需求描述" name="content" span='2'>{{form.content}}</a-descriptions-item>
        </a-descriptions>
        <br />
        <h4>需求回复：</h4>
        <br />
        <a-descriptions bordered v-if="ReplyList" :column="2">
            <a-descriptions-item label="回复时间" name="createdTime"  v-model="financeConsultationReplyList.createdTime" span='2'>{{financeConsultationReplyList.createdTime}}</a-descriptions-item>
            <a-descriptions-item label="回复内容" name="replyContent"  v-model="financeConsultationReplyList.replyContent" span='2'>{{financeConsultationReplyList.replyContent}}</a-descriptions-item>
        </a-descriptions>
        
        <a-form v-else layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <div class="hidden">
                        <a-form-item label="id" name="id">
                            <a-input style="width:100%" v-model:value="form.id"/>
                        </a-form-item>
                    </div>
                    <a-form-item label="需求内容" name="replyContent">
                        <a-textarea v-model:value="form.replyContent" placeholder="请输入回复内容"
                            :auto-size="{ minRows: 5, maxRows: 6 }" />
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
            <p style="float:right"><a-button type="primary" @click="onSubmit()">提交</a-button></p>
        </a-form>
    </a-modal>
</template>

<script>
import dataCheck from "@/utils/dataCheck";
import {
    formMixin,dictMixin
} from "@/mixins";
import { financeConsultationReply } from "@/api/finance";
import DictRender from "@/components/other/DictRender";

export default {
    name: "AddOrEditModal",
    mixins: [formMixin,dictMixin],
    components: {DictRender},
    data() {
        return {
            dictNames:"adviserType",
            form: {
                id: null,
                problemType: null,
                businessDescription: null,
                remark: null,
                consultationId: null,
            },
            financeConsultationReplyList: {
                replyContent:null,
                createdTime:null,
            },
            ReplyList:true,
            rules: {
                id: [],
                problemType: [
                    dataCheck.required({ type: 'number' }),
                ],
                replyContent: [
                    dataCheck.required({})
                ],
                businessDescription: [],
            },
        }
    },
    computed: {

    },
    watch: {
        form: {
            handler() {
                this.getfinanceConsultationReply()
            },
        }
    },
    methods: {
        onSubmit() {
            this.$refs.ruleForm
                    .validate()
                    .then((values) => {
                        console.log(values)
                        this.postAction({
                            url: financeConsultationReply.add,
                            params: {
                                replyContent: values.replyContent,
                                consultationId: values.id
                            },
                            isValid: false
                        }
                        ).then((res) => {
                            if(res){
                            this.getfinanceConsultationReply()
                            }
                        })
                    })
        },
        getfinanceConsultationReply() {
            this.ReplyList = false;
            this.getAction({
                url: financeConsultationReply.pageList,
                params: {consultationId: this.form.id},
                returnMsg: true,
            }).then((res) => {
                this.financeConsultationReplyList.replyContent = null
                this.financeConsultationReplyList.createdTime = null
                if(res.data.records){
                    this.financeConsultationReplyList.replyContent = res.data.records[0].replyContent
                    this.financeConsultationReplyList.createdTime = res.data.records[0].createdTime
                }
                console.log('列表',this.financeConsultationReplyList)
                this.ReplyList = true
            });
        }
    },
    created() {
    }
}
</script>

<style scoped lang="less">

</style>
